import { GetOrdersRequest } from "../api/requests/get-orders-request";
import { GetOrderDetailsRequest } from "../api/requests/get-order-details-request";
import { GetOrderItemDetailsRequest } from "../api/requests/get-order-item-details-request";
import CancelOrderRequest from "../api/requests/cancel-order-request";
import { ErrorResponseWrapper } from "../api/errors/error-response-wrapper";
import config from "../environment/environment-config";

/* Order header */
export const FETCH_ORDERS_BEGIN = "FETCH_ORDERS_BEGIN";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
export const FETCH_MERGE_ORDERS_SUCCESS = "FETCH_MERGE_ORDERS_SUCCESS";
export const FETCH_ORDERS_FAILURE = "FETCH_ORDERS_FAILURE";

/* Order detail */
export const FETCH_ORDER_DETAILS_BEGIN = "FETCH_ORDER_DETAILS_BEGIN";
export const FETCH_ORDER_DETAILS_SUCCESS = "FETCH_ORDER_DETAILS_SUCCESS";
export const FETCH_ORDER_DETAILS_FAILURE = "FETCH_ORDER_DETAILS_FAILURE";

/* Order item detail */
export const FETCH_ORDER_ITEM_DETAILS_BEGIN = "FETCH_ORDER_ITEM_DETAILS_BEGIN";
export const FETCH_ORDER_ITEM_DETAILS_SUCCESS =
  "FETCH_ORDER_ITEM_DETAILS_SUCCESS";
export const FETCH_ORDER_ITEM_DETAILS_FAILURE =
  "FETCH_ORDER_ITEM_DETAILS_FAILURE";

/* Order cancellation */
export const CANCEL_ORDER_BEGIN = "CANCEL_ORDER_BEGIN";
export const CANCEL_ORDER_SUCCESS = "CANCEL_ORDER_SUCCESS";
export const CANCEL_ORDER_FAILURE = "CANCEL_ORDER_FAILURE";

export const ORDERS_BASE_URL = config.apiUrls.ordersApi;
export const CONTEXT_PATH = config.contextPath;

const getJson = (response) => {
  if (!response.ok) {
    throw new ErrorResponseWrapper(response);
  }
  return response
    .json()
    .then((data) => data)
    .catch(() => {
      throw new ErrorResponseWrapper(response);
    });
};

/* Order header */
export const fetchOrdersBegin = (request) => ({
  type: FETCH_ORDERS_BEGIN,
  payload: request,
});

export const fetchOrdersSuccess = (orderResponse) => ({
  type: FETCH_ORDERS_SUCCESS,
  payload: { orderResponse },
});

export const fetchOrdersFailure = (errors) => ({
  type: FETCH_ORDERS_FAILURE,
  payload: { errors },
});

/* order detail */
export const fetchOrderDetailsBegin = (request) => ({
  type: FETCH_ORDER_DETAILS_BEGIN,
  payload: request,
});

export const fetchOrderDetailsSuccess = (orderDetailResponse) => ({
  type: FETCH_ORDER_DETAILS_SUCCESS,
  payload: { orderDetailResponse },
});

export const fetchOrderDetailsFailure = (errors) => ({
  type: FETCH_ORDER_DETAILS_FAILURE,
  payload: { errors: errors },
});

/* order item detail */
export const fetchOrderItemDetailsBegin = (request) => ({
  type: FETCH_ORDER_ITEM_DETAILS_BEGIN,
  payload: request,
});

export const fetchOrderItemDetailsSuccess = (orderDetailResponse) => ({
  type: FETCH_ORDER_ITEM_DETAILS_SUCCESS,
  payload: { orderDetailResponse },
});

export const fetchOrderItemDetailsFailure = (error) => ({
  type: FETCH_ORDER_ITEM_DETAILS_FAILURE,
  payload: { error },
});

export const cancelOrderBegin = (url) => ({
  type: CANCEL_ORDER_BEGIN,
  payload: { url },
});

export const cancelOrderSuccess = (data) => ({
  type: CANCEL_ORDER_BEGIN,
  payload: { data },
});

export const cancelOrderFailure = (messages) => ({
  type: CANCEL_ORDER_BEGIN,
  payload: { messages },
});

/**
 * @jsdoc method
 * @name getOrders
 * @methodOf actions.orderActions
 * @description description
 * Get orders
 */
export function getOrders(
  request: GetOrdersRequest,
  merge = false,
  orders: any
) {
  const url = ORDERS_BASE_URL + request.toQueryString();
  return (dispatch) => {
    dispatch(fetchOrdersBegin(request));
    return fetch(url, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) {
          throw new ErrorResponseWrapper(res);
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (merge) {
          data.orders = [...orders, ...data.orders];
        }
        dispatch(fetchOrdersSuccess(data));
      })
      .catch((errorResponse: ErrorResponseWrapper) => {
        errorResponse.getErrorMessages().then((messages) => {
          dispatch(fetchOrdersFailure(messages));
        });
      });
  };
}

export function refreshOrder(request: GetOrdersRequest) {
  const url = ORDERS_BASE_URL + request.toQueryString();
  return fetch(url, { credentials: "same-origin" }).then((res) => {
    if (!res.ok) {
      throw new ErrorResponseWrapper(res);
    } else {
      return res.json();
    }
  });
}

export function getOrderDetail(request: GetOrderDetailsRequest) {
  const url = ORDERS_BASE_URL + request.toQueryString();
  return (dispatch) => {
    dispatch(fetchOrderDetailsBegin(request));
    return fetch(url, { credentials: "same-origin" })
      .then((res) => getJson(res))
      .then((data) => {
        dispatch(fetchOrderDetailsSuccess(data));
        return data;
      })
      .catch(async (errorResponse: ErrorResponseWrapper) => {
        const response = await errorResponse.response;
        dispatch(fetchOrderDetailsFailure(response));
      });
  };
}

export function refreshOrderDetail(request: GetOrderDetailsRequest) {
  const url = ORDERS_BASE_URL + request.toQueryString();
  return fetch(url, { credentials: "same-origin" }).then((res) => {
    if (!res.ok) {
      throw new ErrorResponseWrapper(res);
    }
    return res.json();
  });
}

export function getOrderItemDetails(request: GetOrderItemDetailsRequest) {
  const url = ORDERS_BASE_URL + request.toQueryString();
  return fetch(url, { credentials: "same-origin" }).then((res) => {
    if (!res.ok) {
      throw new ErrorResponseWrapper(res);
    }
    return res.json();
  });
}

export function cancelOrder(request: CancelOrderRequest) {
  const base = CONTEXT_PATH.endsWith("/")
    ? CONTEXT_PATH.slice(0, -1)
    : CONTEXT_PATH;
  const url = base + request.toQueryString();
  return (dispatch) => {
    dispatch(cancelOrderBegin(url));
    return fetch(url, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    }).then((response) => {
      if (!response.ok) {
        throw new ErrorResponseWrapper(response);
      }
      return response.json();
    });
  };
}
